<template>
  <div class="home">
    <head-com></head-com>
    <div class="main">
      <div class="cont bs">
        <h3 class="title">报名管理</h3>
        <div class="tabs">
          <el-form :inline="true" :model="form" class="demo-form-inline">
            <el-form-item>
              <el-select
                v-model="form.postId"
                placeholder="请选择专业"
                size="small"
                clearable
                @change="specialChange"
              >
                <el-option
                  v-for="(item,i) in specialList"
                  :key="i"
                  :label="item.postName"
                  :value="item.postId"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select v-model="form.regHasCourse" placeholder="请选择报名状态" size="small" clearable>
                <el-option label="未激活" value="0"></el-option>
                <el-option label="已激活" value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="small" @click="onSearch">查询</el-button>
              <el-button
                type="primary"
                size="small"
                @click="$router.push('/followingTeachingApplication')"
              >新增继教报名</el-button>
            </el-form-item>
          </el-form>
          <el-table
            :data="tableData"
            border
            max-height="460"
            :cell-style="cellStyle"
            v-loading="loading"
            element-loading-text="拼命加载中"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)"
            highlight-current-row
            :header-cell-style="{background:'#dde9fc',color:'#606266'}"
          >
            <el-table-column type="index" fixed="left" width="50" label="序号"></el-table-column>
            <el-table-column prop="regName" label="姓名" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column label="性别" min-width="80">
              <template slot-scope="scope">{{scope.row.regSex ==0?'男':'女'}}</template>
            </el-table-column>
            <el-table-column prop="regIdcard" label="身份证号" width="180"></el-table-column>
            <el-table-column prop="regTel" label="手机号" min-width="120"></el-table-column>
            <el-table-column prop="entpName" label="培训机构" min-width="150" show-overflow-tooltip></el-table-column>
            <el-table-column label="继教年度" min-width="150" prop="annualName">
              <!-- <template slot-scope="scope">
                {{scope.row.annualType ===0?'第一年度继教':scope.row.annualType ==1?'第二年度继教':''}}
              </template>-->
            </el-table-column>
            <el-table-column prop="postName" label="专业" min-width="150"></el-table-column>

            <el-table-column label="报名状态" min-width="80">
              <template slot-scope="scope">
                <span
                  :class="scope.row.regHasCourse == 0 ? 'noActive' : 'isActive'"
                >{{scope.row.regHasCourse ==0?'未激活':'已激活'}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="affiliatedEnterprise" label="所属企业" min-width="200"></el-table-column>
            <el-table-column label="操作" width="100" fixed="right">
              <template slot-scope="scope">
                <span v-if="scope.row.regHasCourse ==1">-</span>
                <el-button v-else @click="deleteClick(scope.row)" type="primary" size="mini">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <pagination
            :currentPage="currentPage"
            :total="total"
            :limit="limit"
            ref="page"
            @handleCurrentChange="handleCurrentChange"
            @handleSizeChange="handleSizeChange"
          />
        </div>
      </div>
      <!-- 查看学习照片 -->
      <el-dialog title="删除报名" :visible.sync="detailDialog" width="20%" left top="9vh">
        <div class="deleteDialog">
          <p>确认删除报名信息吗？</p>
          <div class="create">
            <el-button type="primary" size="small" @click="deleteInfor">确定</el-button>
            <el-button size="small" @click="detailDialog =false">取消</el-button>
          </div>
        </div>
      </el-dialog>
    </div>
    <footer-com></footer-com>
  </div>
</template>

<script>
import HeadCom from "@/components/Header.vue";
import FooterCom from "@/components/Footer.vue";
import http from "../api/module";
import pagination from "../components/pagination";

export default {
  name: "personRecord",
  components: {
    HeadCom,
    pagination,
    FooterCom
  },
  data() {
    return {
      loading: true,
      currentPage: 1, // 当前页
      limit: 10, // 每页显示数量
      total: 0, // 总条目数
      specialList: JSON.parse(sessionStorage.getItem("specialList")),
      form: {},
      detailDialog: false,
      tableData: [],
      photoInfo: [],
      imgInfo: {},
      regId: ""
    };
  },

  mounted() {
    this.getPostList();
    this.getInfo();
  },
  methods: {
    //表格数据转化
    dataTypeformatter(row) {
      return row.dataType == 0 ? "换证" : "继教";
    },
    // 当前页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getInfo();
    },
    // 每页数
    handleSizeChange(val) {
      this.limit = val;
      this.currentPage = 1;
      this.getInfo();
    },
    specialChange(val) {
      console.log(val);
      this.postId = val;
    },
    onSearch() {
      this.currentPage = 1;
      this.$refs.page.init();
      this.getInfo();
    },
    // 获取注册专业
    getPostList() {
      http
        .getSpecial({
          entpId: sessionStorage.getItem("entpId")
        })
        .then(data => {
          if (data.data.code == "200" || data.data.success == true) {
            this.specialList = data.data.data;
          } else {
            this.$message.error({
              duration: 1000,
              message: data.data.message
            });
          }
        })
        .catch(error => {
          this.$message.error({
            duration: 1000,
            message: "请求失败,请联系管理员!"
          });
        });
    },
    // 报名管理
    getInfo() {
      http
        .registerList({
          pageNum: this.currentPage,
          pageSize: this.limit,
          postId: this.postId,
          regHasCourse: this.form.regHasCourse,
          dataType: this.form.dataType
        })
        .then(data => {
          if (data.data.code == "200" || data.data.success == true) {
            this.loading = false;
            this.total = data.data.total;
            this.tableData = data.data.data.map(item => {
              var finish = item.finishedHourse || 0;
              var total = item.courseTotalHours || 0;
              item.progress = ((finish / total) * 100).toFixed(0) * 1;
              return item;
            });
          } else {
            this.$message.error({
              duration: 1000,
              message: data.data.message
            });
          }
        })
        .catch(error => {
          this.$message.error({
            duration: 1000,
            message: "请求失败，请联系管理员！"
          });
        });
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 8) {
        return row.approvalStatus == "0"
          ? "color:#67C23A"
          : row.approvalStatus == "1"
          ? "color:#F56C6C"
          : "color:#409EFF";
      } else {
        return "";
      }
    },
    studyFormat(row, column) {
      var state = row.overStatus;
      return state == "1" ? "已学完" : state == "2" ? "学习中" : "待学习";
    },
    stateFormat(row) {
      var approvalStatus = row.approvalStatus;
      return approvalStatus == "0"
        ? "通过"
        : approvalStatus == "1"
        ? "不通过"
        : "待审核";
    },
    finishedFormat(row, column) {
      var state = row.courseOver;
      return state == "1" ? "已学完" : state == "2" ? "学习中" : "待学习";
    },
    auditCommit(row) {
      this.btrId = row.btrId;
      this.$confirm("确定提交审核吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          http
            .userSaveTrainingRecords({
              recordId: this.btrId
            })
            .then(data => {
              if (data.data.code == "200" || data.data.success == true) {
                this.$message({
                  type: "success",
                  duration: 1500,
                  message: "操作成功!"
                });
                this.getInfo();
              } else {
                this.$message.error({
                  duration: 1000,
                  message: data.data.message
                });
              }
            })
            .catch(error => {});
        })
        .catch(() => {
          this.$message({
            type: "info",
            duration: 1000,
            message: "已取消审核通过"
          });
        });
    },
    deleteClick(row) {
      this.detailDialog = true;
      this.regId = row.regId;
      var courseId = row.courseId;
      var empId = row.empId;
      this.employeeDetail(empId);
      // this.getPhotoList(regId, courseId, empId);
    },
    //删除
    deleteInfor() {
      http
        .deleteRegister({
          regId: this.regId,
          sysDeleted: 1 // 1删除  2:作废
        })
        .then(data => {
          if (data.data.code == "200" || data.data.success == true) {
            this.$message.success({
              duration: 1000,
              // message: "作废成功!"
              message: `删除成功!`
            });
            this.detailDialog = false;
            this.getInfo();
          } else {
            this.$message.error({
              duration: 1000,
              message: data.data.message
            });
          }
        })
        .catch(error => {
          this.$message.error({
            duration: 1000,
            message: "请求失败，请联系管理员！"
          });
        });
    },
    // 根据用户id获取用户信息
    employeeDetail(empId) {
      http
        .employeeDetail({
          empId: empId
        })
        .then(data => {
          if (data.data.code == "200" || data.data.success == true) {
            this.imgInfo = data.data.data;
          } else {
            this.$message.error({
              duration: 1000,
              message: data.data.message
            });
          }
        })
        .catch(error => {});
    },
    getPhotoList(regId, courseId, empId) {
      http
        .getPhoto({
          regId: regId,
          courseId: courseId,
          empId: empId
        })
        .then(data => {
          if (data.data.code == "200" || data.data.success == true) {
            this.photoInfo = data.data.data.map(item => {
              var invalid = item.invalid; // 审核状态
              item.state =
                invalid === 0 ? "通过" : invalid === 1 ? "不通过" : "待审核";
              var invalidComment = item.invalidComment;
              // var sysUpdatetime = item.sysUpdatetime; // 完成时间
              // var courseOver = item.courseOver;
              // if (courseOver == 1) {
              //   item.sysUpdatetime = sysUpdatetime;
              // } else {
              //   item.sysUpdatetime = "";
              // }
              var cateName = item.cateName;
              var ccName = item.ccName;
              var photoList = item.photoList;
              item.sectionName = cateName + "——" + ccName;
              if (photoList.length) {
                item.photoUrl = photoList[0].photoUrl;
                item.createdate = photoList[0].createdate;
              }
              return item;
            });
          } else {
            this.$message.error({
              duration: 1000,
              message: data.data.message
            });
          }
        })
        .catch(error => {});
    }
  }
};
</script>
<style lang="less" scoped>
/deep/.el-form-item {
  margin-bottom: 20px;
}
.cont {
  border-radius: 6px;
  width: 100%;
  margin: 20px 0;
  background: #ffffff;
  .title {
    font-size: 18px;
    line-height: 60px;
    border-bottom: 1px solid #ddd;
    padding: 0 20px;
    font-weight: normal;
  }
}
.tabs {
  padding: 20px;
}
.small {
  display: inline-block;
  height: 100px;
  width: auto;
}
.imgs {
  width: 100%;
  padding: 0 100px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-around;
  .tag {
    font-size: 16px;
    display: inline-block;
    vertical-align: top;
  }
  img {
    max-height: 140px;
    width: auto;
  }
  .not {
    margin-left: 10px;
    color: rgb(136, 133, 133);
  }
}
.deleteDialog {
  text-align: center;
}
.deleteDialog p {
  margin: 15px 0;
}
.isActive {
  color: #67c23a;
}
.noActive {
  color: #f00;
}
</style>
